import JenisKayu from './JenisKayu';

export default JenisKayu;
